module.exports = __webpack_public_path__ + "img/fan-error.1d34026a.gif";